import { Theme, useStyletron } from "baseui";
import { Hide } from "baseui/icon";
import React from "react";
import { EmptyStateProps } from "./types";
import { HIERARCHY, KIND } from "./constants";
import { StyledHeader, StyledIcon, StyledMessage, StyledMessageContainer, StyledRoot } from "./styled-components";
import { Button, SHAPE, SIZE } from "baseui/button";

export function EmptyState({ header, icon, message, kind, hierarchy, actionButton }: EmptyStateProps) {
  const [css, theme] = useStyletron();

  const styles = hierarchy === HIERARCHY.high ? high(theme, kind) : low(theme, kind);

  const p: any = { size: theme.sizing.scale800, color: styles.color };
  return (
    <StyledRoot $backgroundColor={styles.backgroundColor} $color={styles.color}>
      <StyledIcon>
        {!icon && <Hide color={styles.color} size={theme.sizing.scale800} />}
        {icon && <>{React.cloneElement(icon, p)}</>}
      </StyledIcon>
      <StyledMessageContainer>
        <StyledHeader>{header}</StyledHeader>
        {message && <StyledMessage>{message}</StyledMessage>}
      </StyledMessageContainer>
      {actionButton ? (
        <ActionButton action={actionButton} backgroundColor={styles.actionBackgroundColor} color={styles.color} />
      ) : (
        <span> </span>
      )}
    </StyledRoot>
  );
}

function ActionButton({ action, backgroundColor, color }) {
  if (action.label) {
    return (
      <Button
        disabled={action.disabled}
        isLoading={action.isLoading}
        colors={{ backgroundColor: backgroundColor, color: color }}
        onClick={action.onClick}
        size={SIZE.mini}
        shape={SHAPE.pill}>
        {action.label}
      </Button>
    );
  }

  return null;
}

function low(theme: Theme, kind) {
  switch (kind) {
    case KIND.negative:
      return {
        actionBackgroundColor: theme.colors.bannerActionLowNegative,
        backgroundColor: theme.colors.backgroundNegativeLight,
        color: theme.colors.notificationNegativeText,
      };

    case KIND.positive:
      return {
        actionBackgroundColor: theme.colors.bannerActionLowPositive,
        backgroundColor: theme.colors.backgroundPositiveLight,
        color: theme.colors.notificationPositiveText,
      };

    case KIND.warning:
      return {
        actionBackgroundColor: theme.colors.bannerActionLowWarning,
        backgroundColor: theme.colors.backgroundWarningLight,
        color: theme.colors.notificationWarningText,
      };

    case KIND.primary:
      return {
        actionBackgroundColor: theme.colors.backgroundTertiary,
        backgroundColor: theme.colors.backgroundSecondary,
        color: theme.colors.contentSecondary,
      };

    case KIND.info:
    default:
      return {
        actionBackgroundColor: theme.colors.bannerActionLowInfo,
        backgroundColor: theme.colors.backgroundAccentLight,
        color: theme.colors.notificationInfoText,
      };
  }
}

// @ts-ignore
function high(theme: Theme, kind) {
  switch (kind) {
    case KIND.negative:
      return {
        actionBackgroundColor: theme.colors.bannerActionHighNegative,
        backgroundColor: theme.colors.backgroundNegative,
        color: theme.colors.contentOnColor,
      };

    case KIND.positive:
      return {
        actionBackgroundColor: theme.colors.bannerActionHighPositive,
        backgroundColor: theme.colors.backgroundPositive,
        color: theme.colors.contentOnColor,
      };

    case KIND.warning:
      return {
        actionBackgroundColor: theme.colors.bannerActionHighWarning,
        backgroundColor: theme.colors.backgroundWarning,
        color: theme.colors.notificationWarningText,
      };
    case KIND.primary:
      return {
        actionBackgroundColor: theme.colors.primary,
        backgroundColor: theme.colors.backgroundInversePrimary,
        color: theme.colors.contentInversePrimary,
      };
    case KIND.info:
    default:
      return {
        actionBackgroundColor: theme.colors.bannerActionHighInfo,
        backgroundColor: theme.colors.backgroundAccent,
        color: theme.colors.contentOnColor,
      };
  }
}
